import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Form,
  Input,
  Label,
  Button,
  FormFeedback,
  Modal,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { changeEmailServerInfoList, getEmailServerInfoList, saveEmailServerInfoList, setAdmDataManagementError, setAdmInvoiceManagementError } from "../../store/actions";
import PeriodBtn from "../../components/Filter/PeriodBtn";
import { useState } from "react";
import { cloneDeep, filter } from 'lodash';

const mergeBtn = "Merge";
const unMergeBtn = "Unmerge"

function EmailServerStatusInfo({ toggle, activeTab, isOpen, tabId }) {

  const dispatch = useDispatch();

  const { noticeStr, totalPage, emailServerInfoList } = useSelector(state => ({
    noticeStr: state.admDataManagement.noticeStrEmailServer,
    totalPage: state.admDataManagement.totalPageEmailServer,
    emailServerInfoList: state.admDataManagement.emailServerInfoList,
  }))

  const [mergeBtnText, setMergeBtnText] = useState(mergeBtn);

  const filterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      submitType: "view",

      perPage: 20,
      curPage: 1,
      datePeriod: "",
      fromDate: "",
      toDate: "",
    },

    onSubmit: (values) => {

      // console.log()

      let submitType = values["submitType"];
      const filterParam = {
          limit: values["perPage"],
          curPage: values["curPage"],
          fromDate: values.fromDate?.replace(/-/g, "") ?? "",
          toDate: values.toDate?.replace(/-/g, "") ?? "",
        };

      if (submitType === "view") {
        dispatch(getEmailServerInfoList(filterParam));
      } else if (submitType === "save") {
        const _emailServerInfoList = [];
        emailServerInfoList.forEach(info => {
          if (info.checked) {
            _emailServerInfoList.push(info);
            info.checked = false
          }
        });
        // console.log(_emailServerInfoList)
        if (_emailServerInfoList.length > 0) {
          // console.log(1)
          const failed = _emailServerInfoList.filter(info => {
            const credits = info?.remainingCredits == null ? "" : String(info.remainingCredits).trim();
            const prepaid = info?.remainingPrepaidCredits == null ? "" : String(info.remainingPrepaidCredits).trim();

            return (
              (credits !== "" && !/^\d+$/.test(credits)) ||
              (prepaid !== "" && !/^\d+$/.test(prepaid))
            );
          });

          // console.log(2, failed);
          if (failed.length > 0) {
            // console.log(3, failed)
            dispatch(setAdmDataManagementError("Invalid number format for remaining credits. Use digits only (0–9); commas, spaces, and letters are not allowed."));
          } else {
            // console.log(4, failed)
            dispatch(saveEmailServerInfoList({infoList: _emailServerInfoList, filter: filterParam}))
            dispatch(changeEmailServerInfoList(emailServerInfoList))
          }
          
        } else {
          dispatch(setAdmDataManagementError("Please select a record!"));
        }
      } else if (submitType === mergeBtn) {
        // console.log("merging")
        const _emailServerInfoList = [];

        const checkedIndexes = emailServerInfoList
          .map((item, index) => (item.checked ? index : -1))
          .filter(index => index !== -1);
        
        const isConsecutive = checkedIndexes.every((index, i) => {
          return i === 0 || index === checkedIndexes[i - 1] + 1;
        });

        if (!isConsecutive) {
          dispatch(setAdmDataManagementError("Please select consecutive records to merge"));
          return;
        }

        emailServerInfoList.forEach(info => {
          if (info.checked) {
            _emailServerInfoList.push(info);
          }
        });

        // console.log("checked records: " + _emailServerInfoList.length)

        if (_emailServerInfoList.length > 1) {
          const uniqueValuesInCheckedCells = [
            ...new Set(
              _emailServerInfoList
                .filter(info => info.usageYesterday !== 0)
                .map(info => info.usageYesterday)
            )
          ];
          // console.log(uniqueValuesInCheckedCells)
          if (uniqueValuesInCheckedCells.length <= 1) {
            _emailServerInfoList.forEach((info) => {
              info.checked = false;
              info.usageMergeYn = 'Y'
            })
            // console.log(_emailServerInfoList)
            dispatch(saveEmailServerInfoList({infoList: _emailServerInfoList, filter: filterParam}))
            dispatch(changeEmailServerInfoList(emailServerInfoList))
          } else {
            dispatch(setAdmDataManagementError("Merging cells contain multiple non zero values"));
          }
        } else {
          dispatch(setAdmDataManagementError("Please select atleast two records to merge!"));
        }
      }  else if (submitType === unMergeBtn) {
        // console.log("unmerging")
        const _emailServerInfoList = [];

        emailServerInfoList.forEach(info => {
          if (info.checked) {
            info.checked = false;
            info.usageMergeYn = 'N'
            _emailServerInfoList.push(info);
          }
        });

        if (_emailServerInfoList.length > 1) {
            dispatch(saveEmailServerInfoList({infoList: _emailServerInfoList, filter: filterParam}))
            dispatch(changeEmailServerInfoList(emailServerInfoList))
        } else {
          dispatch(setAdmDataManagementError("Please select atleast two records to unmerge!"));
        }
        setMergeBtnText(mergeBtn)
      }
    }
  })

  const [chkAllFlag, setChkAllFlag] = useState(false);
  const onInfoCheck = (chkIdx, value) => {
    let _emailServerInfoList = cloneDeep(emailServerInfoList);
    let mergedCount = 0;
    let checkedCount = 0;

    if (chkIdx == "chkAll") {
      setChkAllFlag(value);
      _emailServerInfoList = _emailServerInfoList.map((info, idx) => {
        info.checked = value;
        return info;
      })
    } else {
      if (chkAllFlag && !value) setChkAllFlag(false);
      _emailServerInfoList[chkIdx].checked = value
    }

    _emailServerInfoList.forEach((info, idx) => {
        if (info.checked) {
          checkedCount++;
          if (info.usageMergeYn == 'Y') mergedCount++;
        };
    })

    // console.log(mergedCount, checkedCount)
    if (checkedCount == mergedCount) {
      setMergeBtnText(unMergeBtn)
    } else {
      setMergeBtnText(mergeBtn)
    }

    dispatch(changeEmailServerInfoList(_emailServerInfoList));
  }
  // console.log(mergeBtnText)

  const onPageChange = (curPage, perPage) => {
    filterValidation.setFieldValue("submitType", "view");

    if (curPage) {
      // setCurPageInput(curPage);
      filterValidation.setFieldValue("curPage", curPage);
    } else {
      // setCurPageInput(1);
      filterValidation.setFieldValue("curPage", 1);
    }

    if (perPage) {
      filterValidation.setFieldValue("perPage", perPage);
    }

    filterValidation.handleSubmit(filterValidation.values);
  }

  const getMergedInfo = (data, index) => {
    if (data[index].usageMergeYn !== "Y") {
      return { rowSpan: 1, usageValue: data[index].usageYesterday };
    }

    if (index > 0 && data[index - 1].usageMergeYn === "Y") {
      return { rowSpan: 0 };
    }

    let rowSpan = 1;
    let usageValue = data[index].usageYesterday;

    for (let i = index + 1; i < data.length; i++) {
      if (data[i].usageMergeYn === "Y") {
        rowSpan++;
        if (data[i].usageYesterday > usageValue){
          usageValue = data[i].usageYesterday;
        }
      } else {
        break;
      }
    }

    return { rowSpan, usageValue };
  };


  return (
    <TabPane style={activeTab === tabId ? {display: "block"} : {display: "none"}} tabId={tabId}>
      <Row>
        <Col lg={12}>
          <Card>
            <Link onClick={toggle} className="text-dark" to="#">
              <div className="p-4">
                <Media className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-3">
                    <i className="uil uil-file-copy-alt text-primary h2"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <h5 className="font-size-16 mb-1">Data Management</h5>
                  </div>
                  <i className="uil uil-filter font-size-24 text-muted"></i>
                </Media>
              </div>
            </Link>
            <Collapse isOpen={isOpen}>
              <div className="p-4 border-top">
                <Row>
                  <label htmlFor="inscribedDate" className="col-md-1 col-form-label" style={{ paddingTop: '0px' }}>
                    Date
                  </label>
                  <div className="col-md-9">
                    <PeriodBtn
                      formik={filterValidation}
                    />
                  </div>
                </Row>
                <Row >
                  <Col md={2}>&nbsp;</Col>
                  <Col md={3}>&nbsp;</Col>
                  <Col md={3}>
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light col-md-5"
                      onClick={() => {
                        filterValidation.setFieldValue("curPage", 1);
                        filterValidation.setFieldValue("submitType", "view");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Search
                    </button>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </Card>
        </Col>
      </Row>
      {
        noticeStr &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="text-muted mb-0">
                  <p style={{ whiteSpace: "pre" }}>
                    {noticeStr}
                  </p>
                </CardTitle>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
      {
        Array.isArray(emailServerInfoList) && emailServerInfoList.length > 0 &&
        <Row>
          <Col lg={12}>
            <Card>
              <CardTitle className="text-muted mb-0">
                <Row className="mb-3" style={{paddingTop: "25px", paddingLeft: "30px"}}>
                  <span className="col-md-8 button-items">
                    <Button
                      type="button"
                      color="primary"
                      className="waves-effect waves-light col-md-2"
                      onClick={() => {
                        filterValidation.setFieldValue("submitType", "save");
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      type="button"
                      color="primary"
                      className="waves-effect waves-light col-md-3"
                      onClick={() => {
                        filterValidation.setFieldValue("submitType", mergeBtnText);
                        filterValidation.handleSubmit(filterValidation.values);
                      }}
                    >
                      {mergeBtnText} usage
                    </Button>
                  </span>
                </Row>
              </CardTitle>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th style={{ verticalAlign: "middle", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={chkAllFlag}
                            onClick={(e) => onInfoCheck("chkAll", e.target.checked)}
                          />
                        </th>
                        <th style={{textAlign: 'center'}}>Date</th>
                        <th style={{textAlign: 'center'}}>1<br/>0000</th>
                        <th style={{textAlign: 'center'}}>2<br/>0400</th>
                        <th style={{textAlign: 'center'}}>3<br/>0800</th>
                        <th style={{textAlign: 'center'}}>4<br/>1200</th>
                        <th style={{textAlign: 'center'}}>5<br/>1600</th>
                        <th style={{textAlign: 'center'}}>6<br/>2000</th>
                        <th style={{textAlign: 'center'}}>Wecrest sent <br/> (yesterday)</th>
                        <th style={{textAlign: 'center'}}>Brevo</th>
                        <th style={{textAlign: 'center'}}>Remaining credits <br/> (Transactional emails plan)</th>
                        <th style={{textAlign: 'center'}}>Usage <br/> (yesterday)</th>
                        <th style={{textAlign: 'center'}}>Remaining prepaid credits</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        emailServerInfoList.map((info, index) => {
                          const {rowSpan, usageValue} = getMergedInfo(emailServerInfoList, index);
                          return (
                            <tr key={info.chkDate}>
                              <td align="center" style={{ verticalAlign: "middle" }}>
                                <input type="checkbox"
                                  checked={info.checked}
                                  onClick={(e) => onInfoCheck(index, e.target.checked)}
                                />
                              </td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{`${info.chkDate.substring(0, 4)}/${info.chkDate.substring(4, 6)}/${info.chkDate.substring(6, 8)}`}</td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{info.at0000Time || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{info.at0400Time || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{info.at0800Time || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{info.at1200Time || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{info.at1600Time || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{info.at2000Time || "-"}</td>
                              <td style={{ verticalAlign: "middle", textAlign: 'center' }}>{info.wecrestSentYesterday}</td>
                              <td>
                                <Input
                                  className="form-control"
                                  type="text"
                                  placeholder="xx:xx"
                                  onChange={(e) => {
                                    let _emailServerInfoList = cloneDeep(emailServerInfoList);
                                    _emailServerInfoList[index].brevoTime = e.target.value;
                                    dispatch(changeEmailServerInfoList(_emailServerInfoList));
                                  }}
                                  value={info.brevoTime}
                                />
                              </td>
                              <td>
                                <Input
                                  className="form-control"
                                  type="text"
                                  placeholder="xxxxxx"
                                  onChange={(e) => {
                                    if (info.usageMergeYn === 'Y') {
                                      dispatch(setAdmDataManagementError("Unmerge 'Usage (yesterday)' column before updating 'Remaining credits'"))
                                      return;
                                    }
                                    let _emailServerInfoList = cloneDeep(emailServerInfoList);
                                    _emailServerInfoList[index].remainingCredits = e.target.value;
                                    dispatch(changeEmailServerInfoList(_emailServerInfoList));
                                  }}
                                  value={info.remainingCredits}
                                />
                              </td>
                              {rowSpan > 0 && (
                                <td 
                                  rowSpan={rowSpan} 
                                  style={{ verticalAlign: "middle", textAlign: 'center' }}
                                >
                                  {usageValue}
                                </td>
                              )}
                              <td>
                                <Input
                                  className="form-control"
                                  type="text"
                                  placeholder="xxxx"
                                  onChange={(e) => {
                                    let _emailServerInfoList = cloneDeep(emailServerInfoList);
                                    _emailServerInfoList[index].remainingPrepaidCredits = e.target.value;
                                    dispatch(changeEmailServerInfoList(_emailServerInfoList));
                                  }}
                                  value={info.remainingPrepaidCredits}
                                />
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between" style={{ marginTop: "20px" }}>
                  <span className="d-flex align-items-center gap-2">
                    <label
                      htmlFor="perPage"
                    >
                      Entries per page
                    </label>
                    <div style={{ width: "100px" }}>
                      <select
                        className="form-select"
                        name="perPage"
                        onChange={e => { onPageChange(1, e.target.value); }}
                        value={filterValidation.values.perPage}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<<"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) - 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == 1)}
                      >
                        {"<"}
                      </Button>
                    </div>
                    Page{" "}
                    <strong>
                      {filterValidation.values.curPage} of {totalPage}
                    </strong>

                    <Input
                      type="number"
                      min={1}
                      style={{ width: 70 }}
                      max={totalPage}
                      name="curPage"
                      defaultValue={filterValidation.values.curPage}
                      value={filterValidation.values.curPage}
                      onChange={(e) => {
                        const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                        // setCurPageInput(_curPage, totalPage)
                        filterValidation.setFieldValue("curPage", _curPage);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          const _curPage = Math.min(Math.max(e.target.value, 1), totalPage)
                          onPageChange(_curPage, filterValidation.values.perPage);
                        }
                      }}
                    />
                    <div className="d-flex gap-1">
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(Number(filterValidation.values.curPage) + 1, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">"}
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => { onPageChange(totalPage, filterValidation.values.perPage); }}
                        disabled={(filterValidation.values.curPage == totalPage)}
                      >
                        {">>"}
                      </Button>
                    </div>
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      }
    </TabPane>
  )
}

export default EmailServerStatusInfo;